import React from 'react';
import './MedicalIcons.css';

export const StethoscopeIcon = ({ size = 40 }) => {
    return (
        <div className="medical-icon stethoscope-icon" style={{ width: size, height: size }}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="stethGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#1e293b" />
                        <stop offset="100%" stopColor="#0f172a" />
                    </linearGradient>
                    <filter id="iconGlow">
                        <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
                        <feMerge>
                            <feMergeNode in="coloredBlur"/>
                            <feMergeNode in="SourceGraphic"/>
                        </feMerge>
                    </filter>
                </defs>
                
                {/* Ear tubes */}
                <path 
                    d="M 30 20 Q 20 30, 20 45" 
                    stroke="url(#stethGradient)" 
                    strokeWidth="4" 
                    fill="none"
                    strokeLinecap="round"
                    filter="url(#iconGlow)"
                />
                <path 
                    d="M 70 20 Q 80 30, 80 45" 
                    stroke="url(#stethGradient)" 
                    strokeWidth="4" 
                    fill="none"
                    strokeLinecap="round"
                    filter="url(#iconGlow)"
                />
                
                {/* Main tube */}
                <path 
                    d="M 20 45 Q 30 55, 50 70 Q 70 55, 80 45" 
                    stroke="url(#stethGradient)" 
                    strokeWidth="4" 
                    fill="none"
                    strokeLinecap="round"
                    filter="url(#iconGlow)"
                />
                
                {/* Chest piece */}
                <circle 
                    cx="50" 
                    cy="75" 
                    r="12" 
                    fill="url(#stethGradient)"
                    filter="url(#iconGlow)"
                />
                <circle 
                    cx="50" 
                    cy="75" 
                    r="8" 
                    fill="white"
                    opacity="0.3"
                />
            </svg>
        </div>
    );
};

export const ClipboardIcon = ({ size = 40 }) => {
    return (
        <div className="medical-icon clipboard-icon" style={{ width: size, height: size }}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="clipGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#1e293b" />
                        <stop offset="100%" stopColor="#0f172a" />
                    </linearGradient>
                </defs>
                
                {/* Clipboard board */}
                <rect 
                    x="25" 
                    y="15" 
                    width="50" 
                    height="70" 
                    rx="5" 
                    fill="url(#clipGradient)"
                    filter="url(#iconGlow)"
                />
                
                {/* Clip */}
                <rect 
                    x="40" 
                    y="10" 
                    width="20" 
                    height="10" 
                    rx="3" 
                    fill="#f093fb"
                />
                
                {/* Paper lines */}
                <line x1="35" y1="30" x2="65" y2="30" stroke="white" strokeWidth="2" opacity="0.8"/>
                <line x1="35" y1="40" x2="65" y2="40" stroke="white" strokeWidth="2" opacity="0.8"/>
                <line x1="35" y1="50" x2="60" y2="50" stroke="white" strokeWidth="2" opacity="0.8"/>
                <line x1="35" y1="60" x2="65" y2="60" stroke="white" strokeWidth="2" opacity="0.8"/>
                <line x1="35" y1="70" x2="55" y2="70" stroke="white" strokeWidth="2" opacity="0.8"/>
            </svg>
        </div>
    );
};

export const DNAHelixLoader = ({ size = 24 }) => {
    return (
        <div className="medical-icon dna-loader" style={{ width: size, height: size }}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="dnaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#1e293b" />
                        <stop offset="50%" stopColor="#0f172a" />
                        <stop offset="100%" stopColor="#f093fb" />
                    </linearGradient>
                </defs>
                
                <g className="dna-helix">
                    {/* Left strand */}
                    <path 
                        d="M 30 10 Q 20 30, 30 50 Q 40 70, 30 90" 
                        stroke="url(#dnaGradient)" 
                        strokeWidth="3" 
                        fill="none"
                        strokeLinecap="round"
                    />
                    
                    {/* Right strand */}
                    <path 
                        d="M 70 10 Q 80 30, 70 50 Q 60 70, 70 90" 
                        stroke="url(#dnaGradient)" 
                        strokeWidth="3" 
                        fill="none"
                        strokeLinecap="round"
                    />
                    
                    {/* Connecting bars */}
                    <line x1="30" y1="20" x2="70" y2="20" stroke="url(#dnaGradient)" strokeWidth="2" opacity="0.6"/>
                    <line x1="35" y1="35" x2="65" y2="35" stroke="url(#dnaGradient)" strokeWidth="2" opacity="0.6"/>
                    <line x1="30" y1="50" x2="70" y2="50" stroke="url(#dnaGradient)" strokeWidth="2" opacity="0.6"/>
                    <line x1="35" y1="65" x2="65" y2="65" stroke="url(#dnaGradient)" strokeWidth="2" opacity="0.6"/>
                    <line x1="30" y1="80" x2="70" y2="80" stroke="url(#dnaGradient)" strokeWidth="2" opacity="0.6"/>
                </g>
            </svg>
        </div>
    );
};

export const SpeakerAvatar = ({ speakerId, color, size = 30 }) => {
    return (
        <div 
            className="speaker-avatar" 
            style={{ 
                width: size, 
                height: size,
                background: `linear-gradient(135deg, ${color} 0%, ${adjustColor(color, -20)} 100%)`
            }}
        >
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                {/* Head */}
                <circle cx="50" cy="40" r="20" fill="white" opacity="0.9"/>
                {/* Body */}
                <path 
                    d="M 30 60 Q 50 70, 70 60 L 70 80 Q 50 90, 30 80 Z" 
                    fill="white" 
                    opacity="0.9"
                />
            </svg>
            <span className="speaker-id">{speakerId}</span>
        </div>
    );
};

// Helper function to adjust color brightness
function adjustColor(color, amount) {
    const clamp = (val) => Math.min(Math.max(val, 0), 255);
    const num = parseInt(color.replace('#', ''), 16);
    const r = clamp((num >> 16) + amount);
    const g = clamp(((num >> 8) & 0x00FF) + amount);
    const b = clamp((num & 0x0000FF) + amount);
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
}

export default { StethoscopeIcon, ClipboardIcon, DNAHelixLoader, SpeakerAvatar };
